import { Component, OnInit, OnDestroy, Input, OnChanges, isDevMode } from '@angular/core';
import { Subscription } from 'rxjs';
import { ConfigService } from 'src/app/services/app.config.service';
import { AppConfig } from 'src/app/domain/appconfig';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AddressService } from 'src/app/services/address.service';
import { ShipmentService } from 'src/app/services/shipment.service';
import { ColliService } from 'src/app/services/colli.service';
import { ClientService } from 'src/app/services/client.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SignalrService } from 'src/app/services/signalr.service';
import { HubConnection } from '@microsoft/signalr';
import { TranslateService } from '@ngx-translate/core';
import { DateValidator, parseDateArrayToDate } from '../validators/date.validators';
import { ADRService } from 'src/app/services/adr.service';
import { ScanService } from 'src/app/services/scan.service';
import { Scan } from 'src/app/domain/Scan';
import * as Leaflet from 'leaflet';
import { getLayers } from '../../dashboard/dashboard.component';
import { formatDate } from '@angular/common';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MailMenuDialogComponent } from '../dialogs/mail-menu-dialog/mail-menu-dialog.component';
import { MailService } from 'src/app/services/mail.service';
import { Router } from '@angular/router';
import { ServicesService } from 'src/app/services/services.service';
import { PrintLabelShipmentDialogComponent } from '../dialogs/print-label-shipment-dialog/print-label-shipment-dialog.component';
import { AuthService, OBPermisssionsLocal } from 'src/app/services/auth.service';
import { TenantService } from 'src/app/services/tenant.service';
import { DeviceAgentSerivce, getOS } from 'src/app/services/DeviceAgent.service';
import { HttpParams } from '@angular/common/http';
import { StepperService } from '../stepper/stepper.service';
import { DangerousGoodsModalWrapperComponent } from '../stepper/dangerous-goods/DangerousGoodsModalWrapper/DangerousGoodsModalWrapper.component';
import { Service } from 'src/app/domain/Service';
import { Colli } from 'src/app/domain/Colli';
import { OBPermissions } from '@alicetms/auth.permissions';


@Component({
  templateUrl: './shipment-preview.component.html',
  selector: 'shipment-preview',
  styleUrls: ['./shipment-preview.component.scss'],
})
export class ShipmentPreviewComponent implements OnInit, OnDestroy, OnChanges {
  @Input() editable: boolean = false;
  @Input() shipmentId?: any;


  shipment: any;
  hubConnection: HubConnection;
  subscription = new Array<Subscription>();
  services: any;
  shipmentUpdatedNotification: boolean = false;
  senderAddressEdit: boolean = false;
  recipientAddressEdit: boolean = false;
  refEdit: boolean = false;
  exchangePalletsEdit: boolean = false;
  servicesEdit: boolean = false;
  notesEdit: boolean = false;
  datesEdit: boolean = false;
  colliEdit: boolean = false;
  editMode: boolean = false;
  editObject: any;
  colliToEdit: any;
  dangerousGoodsEdit: any;
  foundAdrs: any;
  editColliWeight: boolean = false;
  serviceList = new Array<Service>()
  loadingScans: any;
  currentRoute: any;
  serviceSingleSelectEdit: any;
  priceErrorMessage = "";
  priceVaild = false;
  shipmentPrice: any = {};

  loading: boolean = false;
  chosenImage: any;
  scanMapOptions: Leaflet.MapOptions = { layers: getLayers(), zoom: 12, center: Leaflet.latLng(55.676098, 12.568337), };

  map: Leaflet.Map;
  mapVisible: boolean = false;
  lastMarker: any;

  ref: DynamicDialogRef;

  hasPrivateDeliveryService: boolean = false;

  hasPrintLabelPermission: OBPermisssionsLocal.PrintLabels;
  HasPrintBeforeReadyPermission = OBPermisssionsLocal.printLabelBeforeReady;

  serviceForm = new FormGroup({ services: new FormControl(), });
  today: any = formatDate(new Date(), 'yyyy-MM-dd', 'da-DK');

  editDatesForm = new FormGroup({
    pickupDate: new FormControl('', [Validators.required, Validators.pattern('^\\d{2}/\\d{2}/\\d{4}$'), DateValidator.GreaterThanToday]),
    pickupTimeStart: new FormControl(),
    pickupTimeEnd: new FormControl(),
    deliveryDate: new FormControl('', [Validators.required, Validators.pattern('^\\d{2}/\\d{2}/\\d{4}$'), DateValidator.GreaterThanToday]),
    deliveryTimeStart: new FormControl(),
    deliveryTimeEnd: new FormControl(),
  }, { validators: [DateValidator.DeliveryTimeStartParseValidator, DateValidator.DeliveryTimeEndParseValidator, DateValidator.PickupTimeStartParseValidator, DateValidator.PickupTimeEndParseValidator, DateValidator.DeliveryTimeValidator, DateValidator.PickupTimeValidator,], }
  );

  cols: any[] = [
    { field: 'quantity', header: 'COLLIHEADERS.AMOUNT' },
    { field: 'type', header: 'COLLIHEADERS.TYPE' },
    { field: 'barcodes', header: 'COLLIHEADERS.BARCODES' },
    { field: 'description', header: 'COLLIHEADERS.DESCRIPTION' },
    { field: 'weight', header: 'COLLIHEADERS.WEIGHT' },
    { field: 'volume', header: 'COLLIHEADERS.VOLUME' },
    { field: 'length', header: 'COLLIHEADERS.LENGTH' },
    { field: 'width', header: 'COLLIHEADERS.WIDTH' },
    { field: 'height', header: 'COLLIHEADERS.HEIGHT' },
    { field: 'loadMeter', header: 'COLLIHEADERS.LOADMETER' },
  ];

  scans: string[] = new Array<string>();
  trackandTraceScans$ = this.scanService.ScansByTrackAndTrace$;

  // config: AppConfig;
  // tenantLogo: any;

  constructor(public configService: ConfigService, private messageService: MessageService, private confirmationService: ConfirmationService, private addressService: AddressService, private shipmentService: ShipmentService, private colliService: ColliService,
    public clientService: ClientService, private signalr: SignalrService, private translateService: TranslateService, private adrService: ADRService, private scanService: ScanService, private dialogService: DialogService,
    private mailService: MailService, private servicesService: ServicesService, private router: Router, public authService: AuthService, private tenantSerivce: TenantService,
    private deviceAgentService: DeviceAgentSerivce, private stepperService: StepperService) {
    this.hubConnection = this.signalr.CreateConnection('shipment');
  }

  ngOnInit(): void {
    this.hubConnection.start().then(() => {
      if (this.shipmentId) {
        this.hubConnection.on('shipment-updated', () => { this.shipmentUpdatedNotification = true; });
        this.hubConnection.invoke('JoinGroup', `shipment:${this.shipmentId}`).catch(x => { console.log("Failed to join group via signelR") });

      }
    });
    this.currentRoute = this.router.url;
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.forEach(x => x.unsubscribe());
    }
  }

  ngOnChanges() {
    // New shipment is chosen
    if (this.shipmentId) {
      this.refreshShipment();
    } else {
      this.shipment = null;
    }
  }

  //#region PrintFunction
  printLabel() {
    if (!this.shipment.id)
      return;

    if (getOS() === "iOS") {
      let queryParams = new HttpParams().append('printType', 'label');
      queryParams = queryParams.append('shipmentIds', this.shipmentId);
      this.deviceAgentService.PrintLabelFromIOS([this.shipment.id], 'label', queryParams)
    }
    else {
      this.dialogService.open(PrintLabelShipmentDialogComponent, { width: '70vw', data: { id: this.shipment.id, type: 'label' }, header: 'Label ' + this.shipment.waybillNo, }).onClose.subscribe(result => {
        if (result)
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error Occured, Try again' });
      });
    }

  }

  PrintWayBil(shipment: any) {
    if (!this.shipment.id)
      return;

    this.dialogService.open(PrintLabelShipmentDialogComponent, {
      width: '70vw',
      data: { id: this.shipment.id, type: 'shipment' },
      header: 'shipment ' + this.shipment.waybillNo,
    }).onClose.subscribe(result => {
      if (result)
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error Occured, Try again' });
    });
  }
  PrintPod(shipment: any) {
    if (!this.shipment.id)
      return;

    this.dialogService.open(PrintLabelShipmentDialogComponent, {
      width: '70vw',
      data: { id: this.shipment.id, type: 'shipment', isPod: true },
      header: 'shipment ' + this.shipment.waybillNo,
    }).onClose.subscribe(result => {
      if (result)
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error Occured, Try again' });
    });
  }

  openMailMenu(shipment: any) {
    this.ref = this.dialogService.open(MailMenuDialogComponent, { width: '70vw', data: shipment, header: 'Mail menu', });

    this.ref.onClose.subscribe((result: any) => {
      if (result) {
        this.mailService.sendShipmentMail(shipment.id, result.recipient, result.subject, result.text).subscribe({
          next: (res: any) => {
            this.messageService.add({
              severity: 'success',
              summary: this.translateService.instant('MESSAGES.MAILSENDTO') + res.recipient,
              detail: this.translateService.instant('ABOUTPARCEL') + shipment.waybillNo,
            });
          },
          error: (err) => {
            this.messageService.add({
              severity: 'error',
              summary: this.translateService.instant('ERROR'),
              detail: this.translateService.instant('MESSAGES.UNABLETOSENDMAIL'),
            });
          },
        });
      }
    });
  }
  //#endregion

  //#region Leaf_Map
  showMap(scan: Scan) {
    this.chosenImage = null;
    this.mapVisible = false;

    let icon = {
      icon: Leaflet.icon({
        iconSize: [25, 41], iconAnchor: [13, 0],
        iconUrl: '/assets/layout/images/marker-icon.png',
        shadowUrl: '/assets/layout/images/marker-shadow.png',
      }),
    };

    if (scan.latitude && scan.longitude) {
      this.mapVisible = true;
      if (!this.map) {
        this.map = Leaflet.map('map').setView([scan.longitude, scan.latitude], 12);
      } else {
        this.map.setView([scan.longitude, scan.latitude], 12);
      }

      Leaflet.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
      }).addTo(this.map);

      if (this.lastMarker) {
        this.map.removeLayer(this.lastMarker);
      }

      this.lastMarker = Leaflet.marker([scan.longitude, scan.latitude], icon).addTo(this.map);

      setTimeout(() => {
        this.map.invalidateSize(true);
      }, 0);
    } else {
      this.messageService.add({
        severity: 'info',
        summary: this.translateService.instant('MESSAGES.NOLOCATION'),
        detail: this.translateService.instant('MESSAGES.NOLOCATIONFORSCAN'),
      });
    }
  }
  //#endregion

  //#region Scans
  getScans() {
    this.GetScansV2()
    // if (this.shipment?.trackAndTrace) {
    //   this.loadingScans = true;
    //   const trackAndTraceToSearch = this.shipment.trackAndTrace;
    //   this.scanService.getScansByTrackAndTrace(trackAndTraceToSearch).subscribe({
    //     next: (scans: Scan[]) => {
    //       if (this.shipment) {
    //         if (scans && scans.length > 0) {
    //           if (this.shipment.trackAndTrace == trackAndTraceToSearch) {
    //             this.shipment.scans = [];
    //             this.shipment.scans = scans;
    //             this.scanService.ScansByTrackAndTrace$.next(scans)
    //           }
    //         }
    //       }
    //       this.loadingScans = false;
    //     },
    //     error: (error) => {
    //       this.loadingScans = false;
    //     },
    //   });
    // }
  }
  GetScansV2() {
    if (!this.shipment?.trackAndTrace)
      return;
    this.scanService.getScansByTrackAndTraceV2(this.shipment?.trackAndTrace);

  }
  //#endregion

  //#region Div_utiltlys
  totalLoadmeter() {
    return (this.shipment.collis as Colli[])?.map((x) => x.loadMeter).reduce((a, b) => a + b, 0);
  }

  totalWeight() {
    return this.shipment.collis?.map((x) => x.weight).reduce((a, b) => a + b, 0).toFixed(2);
  }

  totalAmount() {
    return this.shipment.collis?.map((x) => x.quantity).reduce((a, b) => a + b, 0);
  }

  closeEdit() {
    // this.CheckForPriceing();
    this.editMode = false;
    this.senderAddressEdit = false;
    this.recipientAddressEdit = false;
    this.refEdit = false;
    this.exchangePalletsEdit = false;
    this.servicesEdit = false;
    this.notesEdit = false;
    this.datesEdit = false;
    this.colliEdit = false;
    this.dangerousGoodsEdit = false;
    this.editColliWeight = false;
    this.serviceSingleSelectEdit = false;
    this.services = null;
  }

  openImage(file: any) {
    if (file) {
      this.mapVisible = false;
      this.chosenImage = file;
    }
  }

  private sanitizeTimeOnlyFields(shipment: any) {
    const timeFields = ['pickupTimeStart', 'pickupTimeEnd', 'deliveryTimeStart', 'deliveryTimeEnd'];
    timeFields.forEach((field) => {
      if (shipment[field] && shipment[field].includes('.')) {
        shipment[field] = shipment[field].replace('.', ':');
      }
    });
  }

  shipmentWithinDeadline(shipment: any) {
    if (this.clientService.clientReadyDeadline) {
      const [hours, minutes, seconds] = this.clientService.clientReadyDeadline.split(':').map(Number);
      var pickupDate = new Date(shipment.pickupDate).setHours(hours, minutes, seconds);
      var pickupDatewithReadyDeadline = new Date(pickupDate);

      if (pickupDatewithReadyDeadline < new Date())
        return false;
    }
    return true;
  }

  refreshShipment() {
    this.loading = true;
    this.shipment = null;
    this.scanMapOptions = null;
    this.editMode = false;
    this.mapVisible = false;
    this.chosenImage = null;
    this.map = null;
    this.shipmentUpdatedNotification = false;
    this.closeEdit();
    this.shipmentService.getFullShipment(this.shipmentId).subscribe({
      next: (shipment) => {

        this.shipment = shipment;
        let tempcollis = new Array<any>();

        shipment.collis.forEach(x => {
          if (tempcollis.filter(y => y.lineId == x.lineId).length < 1)
            tempcollis.push({
              agreementId: x.agreementId,
              barcodes: x.barcodes,
              barcode: x.barcode,
              id: x.id,
              lineId: x.lineId,
              quantity: 1,
              type: x.type,
              typeCode: x.typeCode,
              colliTypeRef: x.colliTypeRef,
              ref4: x.ref4,
              description: x.description,
              height: x.height,
              volume: x.volume,
              width: x.width,
              length: x.length,
              loadMeter: x.loadMeter,
              shipmentId: x.shipmentId,
              weight: x.weight
            } as Colli)
          else {
            let foundcolli = tempcollis.find(y => y.lineId == x.lineId) as Colli
            foundcolli.weight += x.weight;
            foundcolli.volume += x.volume;
            foundcolli.loadMeter += x.loadMeter;
            foundcolli.quantity += 1;
          }
        });
        this.shipment.collis = tempcollis;
        if (!this.shipment.fullExchangePallets) {
          this.shipment.fullExchangePallets = {};
        }
        if (!this.shipment.halfExchangePallets) {
          this.shipment.halfExchangePallets = {};
        }
        if (!this.shipment.quarterExchangePallets) {
          this.shipment.quarterExchangePallets = {};
        }
        this.sanitizeTimeOnlyFields(this.shipment);
        this.loading = false;
        this.getScans();
      },
      error: (error) => {
        this.loading = false;
        this.messageService.add({
          severity: 'error',
          summary: this.translateService.instant('ERROR'),
          detail: this.translateService.instant('MESSAGES.UNABLETOGETSHIPMENTS'),
        });
      },
    });
  }
  ParseToFloat(value: string | number | any): number {
    return Number.parseFloat(value + "");
  }
  //#endregion

  //#region Collis
  editColli(colli: any) {
    if (!this.shipment.carrier || this.shipment.carrier.toLowerCase() == 'internal') {
      this.editMode = true;
      this.colliEdit = true;
      if (colli) {
        colli.shipmentId = this.shipment.id;
        this.colliToEdit = Object.assign({}, colli);
      } else {
        this.colliToEdit = {};
      }
    } else {
      this.editColliWeight = true;
      colli.shipmentId = this.shipment.id;
      this.colliToEdit = Object.assign({}, colli);
    }
  }

  saveColli() {
    this.editMode = false;
    this.colliEdit = false;
    this.editColliWeight = false;
    this.loading = true;    
    if (true) {
      // this does both things by doing the logic that what this is sending is how the shipment should look
      // and therefor no need to check or up the whole shipment just the collis      
      let shipmentCollis = new Array<any>();
      let changedColli = (this.colliToEdit as Colli);

      (this.shipment.collis as Colli[]).filter(x => x.lineId != changedColli.lineId).forEach(x => {
        for (let i = 0; i < x.quantity; i++) {
          shipmentCollis.push({
            lineId: x.lineId,
            shipmentId: x.shipmentId ?? this.shipmentId,
            type: x.type,
            typeCode: x.typeCode,
            description: x.description ?? undefined,
            agreementId: x.agreementId,
            weight: (x.weight ?? 0) / x.quantity,
            length: x.length ?? 0,
            width: x.width ?? 0,
            height: x.height ?? 0,
            loadMeter: x.loadMeter ? (Number.parseFloat(x.loadMeter.toString()) / x.quantity).toFixed(2) : 0,
            volume: x.volume ? (Number.parseFloat(x.volume.toString()) / x.quantity).toFixed(2) : 0,
            barcode: "",
          } as Colli);
        }
      });

      for (let i = 0; i < changedColli.quantity; i++) {
        shipmentCollis.push({
          lineId: changedColli.lineId == "" || !changedColli.lineId ? "00000000-0000-0000-0000-000000000000" : changedColli.lineId,
          shipmentId: changedColli.shipmentId ?? this.shipmentId,
          type: changedColli.type,
          typeCode: changedColli.typeCode,
          description: changedColli.description ?? undefined,
          agreementId: changedColli.agreementId,
          weight: (changedColli.weight ?? 0) / changedColli.quantity,
          length: changedColli.length ?? 0,
          width: changedColli.width ?? 0,
          height: changedColli.height ?? 0,
          loadMeter: changedColli.loadMeter ? (Number.parseFloat(changedColli.loadMeter.toString()) / changedColli.quantity).toFixed(2) : 0,
          volume: changedColli.volume ? (Number.parseFloat(changedColli.volume.toString()) / changedColli.quantity).toFixed(2) : 0,
          barcode: "",
        } as Colli);
      }
      this.colliService.UpsertColliLines(this.shipmentId, shipmentCollis).subscribe(x => {
        this.messageService.add({
          severity: 'success',
          summary: this.translateService.instant('UPDATED'),
          detail: this.translateService.instant('MESSAGES.COLLIUPDATED'),
        });
        this.CheckForPriceing();
        this.shipment.collis = this.groupCollisByLineId(x.item.colli);
        this.loading = false;
      });
    }
    else {
      if (this.colliToEdit.lineId) {
        this.colliToEdit.barcodes = [];
        this.colliService.updateColliLine(this.colliToEdit).subscribe((colli) => {
          if (colli) {
            this.shipmentService.getFullShipment(this.shipment.id).subscribe((shipment) => {
              this.shipment = shipment;
              this.messageService.add({
                severity: 'success',
                summary: this.translateService.instant('UPDATED'),
                detail: this.translateService.instant('MESSAGES.COLLIUPDATED'),
              });
              this.loading = false;
              this.CheckForPriceing();
            });
          }
        });
      } else {
        this.colliToEdit.shipmentId = this.shipment.id;
        this.colliService.createColli(this.colliToEdit).subscribe((colli) => {
          this.shipmentService.getFullShipment(this.shipment.id).subscribe((shipment) => {
            this.shipment = shipment;
            this.messageService.add({
              severity: 'success',
              summary: this.translateService.instant('CREATED'),
              detail: this.translateService.instant('MESSAGES.COLLICREATED'),
            });
            this.loading = false;
            this.CheckForPriceing();
          });
        });
      }
    }
  }

  checkColliAgreement() {
    const { colliToEdit } = this;
    const { type } = colliToEdit;
    const chosenType = this.clientService.clientAgreements.find((x) => x.colliName === type);

    if (!type) {
      return true;
    }

    if (!chosenType) {
      return false;
    }

    const { length, width, height, volume, loadMeter, weight, description } = colliToEdit;

    if (chosenType.length && !length) {
      return true;
    }

    if (chosenType.width && !width) {
      return true;
    }

    if (chosenType.height && !height) {
      return true;
    }

    if (chosenType.volume && !volume) {
      return true;
    }

    if (chosenType.ldm && !loadMeter) {
      return true;
    }

    if (chosenType.weight && !weight) {
      return true;
    }

    if (chosenType.text && !description) {
      return true;
    }
    return false;
  }

  groupCollisByLineId(collis: Colli[]): Colli[] {
    return collis.reduce((result: Colli[], current: Colli) => {
      let existing = result.find(c => c.lineId === current.lineId);

      if (!existing) {
        result.push({
          ...current,
          quantity: 1,
          weight: Number(current.weight ?? 0),
          loadMeter: Number(current.loadMeter ?? 0),
          volume: Number(current.volume ?? 0),
          barcode: "",
          barcodes: []
        });
        return result;
      }

      existing.quantity = (existing.quantity ?? 1) + 1;
      existing.weight = Number(existing.weight ?? 0) + Number(current.weight ?? 0);
      existing.loadMeter = Number(existing.loadMeter ?? 0) + Number(current.loadMeter ?? 0);
      existing.volume = Number(existing.volume ?? 0) + Number(current.volume ?? 0);
      existing.barcode = "";
      existing.barcodes = [];
      return result;
    }, []);
  }

  deleteColli(colli: any) {
    this.confirmationService.confirm({
      message: this.translateService.instant('COLLIDELETEMESSAGE'),
      header: this.translateService.instant('DELETECOLLI'),
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: this.translateService.instant('GENERIC.YES'),
      rejectLabel: this.translateService.instant('GENERIC.CLOSE'),
      key: 'deleteColliConfirm',
      accept: () => {
        this.loading = true;
        if (true || isDevMode()) {
          var shipmentCollis = new Array<Colli>();
          (this.shipment.collis as Colli[]).filter(x => x.lineId != colli.lineId).forEach(x => {
            for (let i = 0; i < x.quantity; i++) {
              shipmentCollis.push({
                lineId: x.lineId,
                shipmentId: x.shipmentId ?? this.shipmentId,
                type: x.type,
                typeCode: x.typeCode,
                description: x.description ?? undefined,
                agreementId: x.agreementId,
                weight: (x.weight ?? 0) / x.quantity,
                length: x.length ?? 0,
                width: x.width ?? 0,
                height: x.height ?? 0,
                loadMeter: x.loadMeter ? (Number.parseFloat(x.loadMeter.toString()) / x.quantity).toFixed(2) : 0,
                volume: x.volume ? (Number.parseFloat(x.volume.toString()) / x.quantity).toFixed(2) : 0,
                barcode: "",
              } as Colli);
            }
          });

          this.colliService.UpsertColliLines(this.shipmentId, shipmentCollis).subscribe(x => {
            this.loading = false;
            this.shipment.collis = this.groupCollisByLineId(x.item.colli);
            this.CheckForPriceing();

          })
        }
        else
          if (colli.lineId) {
            if (colli.quantity > 1) {
              this.colliService.deleteColliLine(colli).subscribe({
                next: (res) => {
                  this.shipment.collis = this.shipment.collis.filter((x) => x.lineId !== colli.lineId);
                  this.messageService.add({
                    severity: 'success',
                    summary: this.translateService.instant('DELETED'),
                    detail: this.translateService.instant('MESSAGES.COLLIDELETED'),
                  });
                  this.loading = false;
                  this.CheckForPriceing();
                },
                error: (err) => { },
              });
            } else {
              this.colliService.deleteColli(colli).subscribe((res) => {
                this.shipmentService.getFullShipment(this.shipment.id).subscribe((shipment) => {
                  this.shipment = shipment;
                  this.messageService.add({
                    severity: 'success',
                    summary: this.translateService.instant('DELETED'),
                    detail: this.translateService.instant('MESSAGES.COLLIDELETED'),
                  });
                });
                this.loading = false;
                this.CheckForPriceing();
              });
            }
          }
      },
      reject: () => { },
    });
  }

  checkCollis() {
    if (this.shipment.collis && this.shipment.collis.length > 0) {
      if (this.shipment.collis.some((x) => x.type == 'GLS') || this.shipment.collis.some((x) => x.type == 'PC')) {
        return false;
      }
    }
    if (this.shipment.carrier && this.shipment.carrier == 'GLS') {
      return false;
    }
    if (this.shipment.carrier && this.shipment.carrier == 'PostNord') {
      return false;
    }
    if (this.shipment.carrier && this.shipment.carrier.toLowerCase() != 'internal') {
      return false;
    }

    return true;
  }

  //#endregion

  //#region Addrese
  editSenderAddress() {
    this.editMode = true;
    this.senderAddressEdit = true;
    this.editObject = Object.assign({}, this.shipment.senderAddress);
  }

  saveSenderAddress() {
    this.closeEdit();
    this.loading = true;
    this.addressService.updateShipmentAddress(this.editObject, this.shipment.id).subscribe((address) => {
      this.shipment.senderAddress = this.editObject;
      this.messageService.add({
        severity: 'success',
        summary: this.translateService.instant('UPDATED'),
        detail: this.translateService.instant('MESSAGES.SENDERADDRESSUPDATED'),
      });
      this.loading = false;
    });
  }

  editRecipientAddress() {
    this.editMode = true;
    this.recipientAddressEdit = true;
    this.editObject = Object.assign({}, this.shipment.recipientAddress);
  }

  saveRecipientAddress() {
    this.closeEdit();
    this.loading = true;
    this.addressService.updateShipmentAddress(this.editObject, this.shipment.id).subscribe((address) => {
      this.shipment.recipientAddress = this.editObject;
      this.messageService.add({
        severity: 'success',
        summary: this.translateService.instant('UPDATED'),
        detail: this.translateService.instant('MESSAGES.RECEIVERADDRESSUPDATED'),
      });
      this.loading = false;
    });
  }
  //#endregion

  //#region Dates
  editDates() {
    this.editMode = true;
    this.datesEdit = true;
    this.editObject = Object.assign({}, this.shipment);
    if (this.editObject.pickupDate) {
      this.editObject.pickupDate = this.formatDate(this.editObject.pickupDate);
    }
    this.editObject.deliveryDate = this.formatDate(this.editObject.deliveryDate);

    if (this.editObject.carrier.toLowerCase() != 'internal') {
      this.editDatesForm.get('pickupDate').clearValidators();
      this.editDatesForm.get('pickupDate').updateValueAndValidity();
    } else {
      if (this.clientService.clientReadyDeadline) {
        const [hours, minutes, seconds] = this.clientService.clientReadyDeadline.split(':').map(Number);
        var pickupDate = new Date(parseDateArrayToDate(this.editObject.pickupDate)).setHours(hours, minutes, seconds);
        var pickupDatewithReadyDeadline = new Date(pickupDate);
        if (pickupDatewithReadyDeadline < new Date()) {
          this.editDatesForm.get('pickupDate').setValidators([Validators.required, Validators.pattern('^\\d{2}/\\d{2}/\\d{4}$'), DateValidator.GreaterThanToday]);
          this.editDatesForm.addValidators([DateValidator.PickupDateGreaterThanToday]);
        } else {
          // User is able to set pickupdate to today
          this.editDatesForm.get('pickupDate').setValidators([Validators.required, Validators.pattern('^\\d{2}/\\d{2}/\\d{4}$'), DateValidator.GreaterThanOrEqualToday]);
          this.editDatesForm.addValidators([DateValidator.PickupDateGreaterThanOrEqualToday]);
        }
      } else {
        this.editDatesForm.get('pickupDate').setValidators([Validators.required, Validators.pattern('^\\d{2}/\\d{2}/\\d{4}$'), DateValidator.GreaterThanToday]);
        this.editDatesForm.addValidators([DateValidator.PickupDateGreaterThanToday]);
      }
    }
    this.editDatesForm.patchValue(this.editObject);
    this.editDatesForm.valueChanges.subscribe((val) => {
      this.editObject.pickupDate = val.pickupDate;
      this.editObject.deliveryDate = val.deliveryDate;
      this.editObject.pickupTimeStart = val.pickupTimeStart;
      this.editObject.pickupTimeEnd = val.pickupTimeEnd;
      this.editObject.deliveryTimeStart = val.deliveryTimeStart;
      this.editObject.deliveryTimeEnd = val.deliveryTimeEnd;
    });
  }

  saveDates() {
    if (!this.editDatesForm.invalid) {
      this.closeEdit();
      if (this.editObject.pickupDate) {
        this.editObject.pickupDate = this.parseDate(this.editObject.pickupDate).toDateString();
      }
      this.editObject.deliveryDate = this.parseDate(this.editObject.deliveryDate).toDateString();
      this.updateShipmentDates(this.editObject);
    } else {
    }
  }

  updateShipmentDates(shipment: any) {
    this.loading = true;
    this.shipmentService.updateShipmentDates(shipment).subscribe({
      next: (shipment) => {
        this.shipmentService.getFullShipment(this.shipment.id).subscribe((shipment) => {
          this.shipment = shipment;
          this.sanitizeTimeOnlyFields(this.shipment);
          this.messageService.add({
            severity: 'success',
            summary: this.translateService.instant('UPDATED'),
            detail: this.translateService.instant('MESSAGES.DATESUPDATED'),
          });
          this.loading = false;
        });
      },
      error: (err) => {
        this.loading = false;
        this.messageService.add({
          severity: 'error',
          summary: this.translateService.instant('ERROR'),
          detail: this.translateService.instant('MESSAGES.UNABLETOUPDATEDATES'),
        });
      },
    });
  }

  setDeliveryDateToToday() {
    this.confirmationService.confirm({
      message: this.translateService.instant('DELIVERYDATETODAYMESSAGE') + `${this.formatDate(this.today)}?`,
      header: this.translateService.instant('DELIVERYDATETODAY'),
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: this.translateService.instant('GENERIC.YES'),
      rejectLabel: this.translateService.instant('GENERIC.CANCEL'),
      key: 'setDeliveryDateToTodayConfirm',
      accept: () => {
        this.loading = true;
        this.shipment.deliveryDate = this.today;

        this.shipmentService.updateShipmentDates(this.shipment).subscribe({
          next: (shipment) => {
            this.shipmentService.getFullShipment(this.shipment.id).subscribe((shipment) => {
              this.shipment = shipment;
              this.sanitizeTimeOnlyFields(this.shipment);
              this.messageService.add({
                severity: 'success',
                summary: this.translateService.instant('UPDATED'),
                detail: this.translateService.instant('MESSAGES.DELIVERYDATESETTOTODAY'),
              });
              this.loading = false;
            });
          },
          error: (err) => {
            this.loading = false;
            this.messageService.add({
              severity: 'error',
              summary: this.translateService.instant('ERROR'),
              detail: this.translateService.instant('MESSAGES.UNABLETOUPDATEDATES'),
            });
          },
        });
      },
      reject: () => { },
    });
  }

  formatDate(dateStr: string): string {
    const date = new Date(dateStr);
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const year = date.getFullYear();
    return `${day.toString().padStart(2, '0')}/${month.toString().padStart(2, '0')}/${year}`;
  }

  parseDate(dateStr: string): Date {
    const [day, month, year] = dateStr.split('/').map(Number);
    return new Date(year, month - 1, day);
  }
  //#endregion

  //#region Notes
  editNotes() {
    this.editMode = true;
    this.notesEdit = true;
    this.editObject = Object.assign({}, this.shipment);
  }

  saveNotes() {
    this.closeEdit();
    if (this.editObject.note != this.shipment.note) {
      this.updateShipmentDetails(this.editObject);
    }
  }

  //#endregion

  //#region ExchangePallets
  editExchangePallets() {
    this.editMode = true;
    this.exchangePalletsEdit = true;
    this.editObject = JSON.parse(JSON.stringify(this.shipment)); // Fix - find a faster way to deep copy shipment... (Lodash?)
  }

  saveExchangePallets() {
    this.closeEdit();
    this.loading = true;
    this.updateShipmentExchangePallets(this.editObject);
  }

  updateShipmentExchangePallets(shipment: any) {
    this.shipmentService.updateShipmentExchangePallets(shipment).subscribe({
      next: (shipment) => {
        this.shipmentService.getFullShipment(this.shipment.id).subscribe((shipment) => {
          this.shipment = shipment;
          this.messageService.add({
            severity: 'success',
            summary: this.translateService.instant('UPDATED'),
            detail: this.translateService.instant('MESSAGES.EXCHANGEPALLETSUPDATED'),
          });
        });
        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
        this.messageService.add({
          severity: 'error',
          summary: this.translateService.instant('ERROR'),
          detail: this.translateService.instant('MESSAGES.UNABLETOUPDATEEXCHANGEPALLETS'),
        });
      },
    });
  }

  //#endregion

  //#region Refs

  editRefs() {
    this.editMode = true;
    this.refEdit = true;
    this.editObject = Object.assign({}, this.shipment);
  }

  saveRefs() {
    this.closeEdit();
    this.updateShipmentDetails(this.editObject);
  }
  //#endregion

  //#region Services

  editServices() {
    this.editObject = Object.assign([], this.shipment);
    if (this.editObject.services && this.editObject.services.length == 0) {
      this.editObject.services = null;
    }
    if (!this.shipment.carrier || this.shipment.carrier == 'Internal') {
      this.services = this.clientService.clientServices ?? [];
    }
    if (!this.services) {
      this.servicesService.getExternalServicesByCarrier(this.shipment.carrier, this.shipment.bookingType).subscribe((result: any) => {
        this.services = result.services;
        this.editMode = true;
        if (this.shipment.carrier == 'GLS') {
          this.serviceSingleSelectEdit = true;

          if (this.editObject.services && this.editObject.services.length > 0) {
            const privateDelivery = this.editObject.services.find((x: any) => x == 'PrivateDelivery');
            if (privateDelivery) {
              this.hasPrivateDeliveryService = true;
              this.editObject.services = this.editObject.services.filter((x: any) => x != 'PrivateDelivery');
              if (this.editObject.services.length == 0) {
                this.editObject.services = null;
              }
            }
          }
        } else {
          this.servicesEdit = true;
        }
      });
    } else {
      this.editMode = true;
      this.servicesEdit = true;
    }
  }

  CheckServiceAdr(service: any) {
    let servicename = service.name;
    if ((servicename == "Farliggods" || servicename == "Farlig Gods" || servicename == "ADR" || servicename == "Farligt gods") && this.shipment.dangerousGoods.length > 0)
      return true;
    else
      return false;

  }

  saveServices() {
    this.closeEdit();

    if (this.editObject.services === null) {
      this.editObject.services = [];
    }
    if (!Array.isArray(this.editObject.services)) {
      this.editObject.services = [this.editObject.services];
    }
    if (this.hasPrivateDeliveryService) {
      this.editObject.services.push('PrivateDelivery');
    }
    if ((this.editObject.services as string[]).includes("FOR") && this.authService.hasPermission(OBPermissions.BookInsurance)) {
      this.updateShipmentServices(this.editObject, this.shipment.insuranceAmount ?? 0);
    }
    else
      this.updateShipmentServices(this.editObject);
  }

  //#endregion

  //#region DangerousGoods

  editDangerousGoods() {
    this.stepperService.newShipment = this.shipment;
    this.OpenDangerousGoodsEditModal();
  }

  OpenDangerousGoodsEditModal() {
    this.dialogService.open(DangerousGoodsModalWrapperComponent, { modal: true, showHeader: true, header: this.stepperService.newShipment.waybillNo.toString(), height: "50%", width: "80%" }).onClose.subscribe(x => {
      if (x != undefined)
        this.updateShipmentDangerousGoods(this.stepperService.newShipment)
      this.CheckForPriceing();
    });
  }

  saveDangerousGoods() {
    this.closeEdit();
    this.updateShipmentDangerousGoods(this.editObject);
  }

  adrSearch(event: any) {
    this.adrService.searchADR(event.query).subscribe((data: any) => {
      if (data && data.items) {
        this.foundAdrs = data.items;
      }
    });
  }
  updateShipmentDangerousGoods(fromHtmlShipment: any) {
    if (fromHtmlShipment.dangerousGoods.length > 0)
      this.shipmentService.updateShipmentDangerousGoods(fromHtmlShipment).subscribe({
        next: (shipment) => {
          this.shipmentService.getFullShipment(this.shipment.id).subscribe((shipment) => {
            this.shipment = shipment;
            this.messageService.add({
              severity: 'success',
              summary: this.translateService.instant('UPDATED'),
              detail: this.translateService.instant('MESSAGES.DANGEROUSGOODSUPDATED'),
            });
          });
          this.loading = false;
        },
        error: (err) => {
          this.loading = false;
          this.messageService.add({
            severity: 'error',
            summary: this.translateService.instant('ERROR'),
            detail: this.translateService.instant('MESSAGES.UNABLETOUPDATEDANGEROUSGOODS'),
          });
        },
      });
  }

  dangerousGoodsChanges(eventValue: any) {
    if (eventValue.data.length > 0) {
      this.shipment.dangerousGoods = eventValue.data;
      this.updateShipmentDangerousGoods(this.shipment)
    }

  }

  //#endregion

  //#region Backend_Service_Calls
  updateShipmentDetails(shipment: any) {
    this.loading = true;
    this.shipmentService.updateShipmentDetails(shipment).subscribe((shipment) => {
      this.shipmentService.getFullShipment(this.shipment.id).subscribe((shipment) => {
        this.shipment = shipment;
        this.messageService.add({
          severity: 'success',
          summary: this.translateService.instant('UPDATED'),
          detail: this.translateService.instant('MESSAGES.SHIPMENTUPDATED'),
        });
        this.loading = false;
      });
    });
  }

  updateShipmentServices(shipment: any, insureanceAmount = 0) {
    this.loading = true;
    this.shipmentService.updateShipmentServices(shipment, insureanceAmount).subscribe({
      next: (shipment) => {
        this.shipmentService.getFullShipment(this.shipment.id).subscribe((shipment) => {
          this.shipment = shipment;
          this.messageService.add({
            severity: 'success',
            summary: this.translateService.instant('UPDATED'),
            detail: this.translateService.instant('MESSAGES.SERVICESUPDATED'),
          });
        });
        this.loading = false;
        this.CheckForPriceing();
      },
      error: (err) => {
        this.loading = false;
        this.messageService.add({
          severity: 'error',
          summary: this.translateService.instant('ERROR'),
          detail: this.translateService.instant('MESSAGES.UNABLETOUPDATESERVICES'),
        });
      },
    });
  }
  //#endregion

  //#region mappers
  MapPriceObjectToShipment(res: any) {
    return {
      priceValid: res.priceValid ?? false,
      totalPrice: res.totalPrice ?? 0.0,
      currency: res.currency ?? "DK",
      priceLines: res.lines ?? new Array<any>()
    };
  }
  //#endregion

  FindServiceByLoggedInUser(service: string): string {
    let foundName = "";
    if (this.serviceList.length > 0 && this.serviceList.find(x => x.code == service) != null) {
      foundName = this.serviceList.find(x => x.code == service).name;
    }
    else if (this.clientService && this.clientService.clientServices && this.clientService.clientServices.find(x => x.code == service) != null) {
      foundName = this.clientService.clientServices.find(x => x.code == service).name
    }
    else {
      this.tenantSerivce.getServices().subscribe((x: Service[]) => {
        let temp = x.find(y => y.code == service);
        foundName = temp != null ? temp.name : "";
      })
    }
    return foundName;
  }

  IsColliScanned(barcode: string) {
    return this.scans.some(s => s === barcode || s === barcode.slice(1, -1));
    // return this.scans.includes(barcode);
  }

  CheckForPriceing() {
    if (isDevMode() || (this.authService.hasFeature('onlinebook_showshipmentprice') && this.authService.hasSetting("feat.showshipmentprice"))) {
      this.checkForChanges(); //JSON.parse(JSON.stringify(this.shipment))
    }
  }

  checkForChanges() {
    // setTimeout(() => {
    if (this.shipment?.collis && this.shipment?.collis.length > 0) {

      if (isDevMode()) {
        let FakePrice = this.CreateFakePriceing();
        this.shipmentPrice = FakePrice;
        this.shipment.price = this.shipmentPrice;
        this.shipmentService.UpdateShipmentPrice(this.shipment).subscribe(x => {
          // this.refreshShipment();
        });
        return;
      }

      this.shipmentService.calculatePrice(this.shipment, true).subscribe((res: any) => {
        this.priceErrorMessage = "";
        if (Number.parseInt(res.currency) > 0) {
          switch (Number.parseInt(res.currency)) {
            case 1:
              this.priceErrorMessage = "ukendt felj, prøve igen feljkode: " + res.currency;
              this.priceVaild = false;
              break;
            case 2:
              this.priceErrorMessage = "zone ikke fundet feljkode: " + res.currency;
              this.priceVaild = false;
              break;
            case 4:
              this.priceErrorMessage = "interval ikke fundet feljkode: " + res.currency;
              this.priceVaild = false;
              break;
            case 8:
              this.priceErrorMessage = "colli type ikke fundet i prisblad feljkode: " + res.currency;
              this.priceVaild = false;
              break;
            case 16:
              this.priceErrorMessage = "colli oversættelse felj feljkode: " + res.currency;
              this.priceVaild = false;
              break;
            case 32:
              this.priceErrorMessage = "Kunde har ikke noget prisblad feljkode: " + res.currency;
              this.priceVaild = false;
              break;
            case 64:
              this.priceErrorMessage = "Kunde har ikke nogen services feljkode: " + res.currency;
              this.priceVaild = false;
              break;
            case 128:
            case 8192:
            case 4096:
              this.priceErrorMessage = "Kunde ikke fundet. feljkode: " + res.currency;
              this.priceVaild = false;
              break;
            case 256:
              this.priceErrorMessage = "Produkter ikke fundet i prisblad feljkode: " + res.currency;
              this.priceVaild = false;
              break;
            case 512:
              this.priceErrorMessage = "ingen pris i prisblad feljkode: " + res.currency;
              this.priceVaild = false;
              break;
            case 1024:
              this.priceErrorMessage = "ingen pris fundet til udrenging af ldm priser.feljkode: " + res.currency;
              this.priceVaild = false;
              break;
            case 2048:
              this.priceErrorMessage = "standart colli type ikke fundet. feljkode: " + res.currency;
              this.priceVaild = false;
              break;
            case 16384:
              this.priceErrorMessage = "kreditor ikke fundet. feljkode: " + res.currency;
              this.priceVaild = false;
              break;
            default:
              this.priceVaild = true;
              break;
          }
        }

        this.shipmentPrice = this.MapPriceObjectToShipment(res);
        this.shipment.price = this.shipmentPrice;

        this.shipmentService.UpdateShipmentPrice(this.shipment).subscribe(x => {
          // this.refreshShipment();
          console.log("UpdatePrice WasUpdated= ", x)
        });

      });
    }
    // }, 50);
  }

  /**
   * creates a local fake price for use in local hosting
   * @returns a fake price dataset
   */
  CreateFakePriceing() {
    return {
      "priceValid": true,
      "totalPrice": 1011.520,
      "currency": "DKK",
      "priceLines": [
        {
          "quantity": 3.0,
          "text": "Fragt",
          "price": 219.00,
          "totalPrice": 657.000
        },
        {
          "quantity": 1.0,
          "text": "Energitillæg 43.01%",
          "price": 282.58,
          "totalPrice": 282.580
        },
        {
          "quantity": 1.0,
          "text": "Kapacitets tillæg 3.95%",
          "price": 25.95,
          "totalPrice": 25.950
        },
        {
          "quantity": 1.0,
          "text": "Vejafgift 7.00%",
          "price": 45.99,
          "totalPrice": 45.990
        }
      ]
    }
  }
}